// A guided conversation's agenda as a printable page (28 Oct 2026):
// /guided/:customer/:responseId/agenda. The person reads the questions before
// they start, and prints it or saves it as a PDF from the browser. The agenda
// is the response's pinned version, else the guide's current one.

import React from 'react'
import { Alert, Box, CircularProgress } from '@mui/material'
import useRouter from '../hooks/useRouter'
import useAccount from '../hooks/useAccount'
import useGuidedResponse from '../hooks/useGuidedResponse'
import GuideAgendaPrint from '../components/guided/GuideAgendaPrint'

export default function GuidedAgendaPage() {
  const router = useRouter()
  const account = useAccount()
  const customer = (router.params.customer as string | undefined) || account.customer?.name || ''
  const responseId = (router.params.responseId as string | undefined) || ''
  const guided = useGuidedResponse({ customer, responseId })
  const view = guided.view

  if (guided.isLoading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress size={28} /></Box>
  }
  if (!view) {
    return (
      <Box sx={{ maxWidth: 640, mx: 'auto', p: 3 }}>
        <Alert severity={guided.notFound ? 'info' : 'error'}>
          {guided.notFound ? 'This agenda was not found. The link may be for someone else.' : guided.error || 'This agenda could not be loaded.'}
        </Alert>
      </Box>
    )
  }
  return (
    <GuideAgendaPrint
      title={view.guide.title}
      intro={view.guide.intro}
      goal={view.guide.goal}
      readersNote={view.guide.readers_note}
      reviewers={view.reviewers}
      points={view.points}
      onPrint={() => window.print()}
      back={{ label: 'Back to the conversation', onClick: () => router.navigate('guided-response', { customer, responseId }) }}
    />
  )
}
